import api from "../../client";

export const deleteLinkRequest = async (
  id: string | undefined,
): Promise<void> => {
  const { data } = await api.delete(`/link/${id}`);

  return data;
};
